import React from "react";
import { Button, useTheme, Text } from "@chakra-ui/react";
import { IoMdAdd } from "react-icons/io";
const CourseTextButton = ({ text, onClick }) => {
  const theme = useTheme();
  const { primaryBlueLight,primaryBlue } = theme.colors.pallete;
  return (
    <Button
      variant="solid"
      onClick={onClick}
      color="white"
      backgroundColor={primaryBlue}
      leftIcon={<IoMdAdd />}
      _hover={{ bg: primaryBlueLight }}
    >
      <Text fontWeight={500}>{text}</Text>
    </Button>
  );
};

export default CourseTextButton;
